export const MEDIA_LIB_FILES_QUERY_KEY = "media-lib-files-key";
export const MEDIA_LIB_IMAGE_MAX_SIZE = 30 * 1024 * 1024;
export const MEDIA_LIB_VIDEO_MAX_SIZE = 30 * 1024 * 1024;
export const MEDIA_LIB_FONT_MAX_SIZE = 10 * 1024 * 1024;

export const MEDIA_LIB_DIALOG_MASONRY_SKELETON_HEIGHTS = [
  [230, 310, 512],
  [310, 230, 412],
  [230, 512, 332],
  [512, 327, 230],
];

export const MEDIA_LIB_TAB_STORAGE_KEY = "media-lib-tab";
